module.exports = __webpack_public_path__ + "img/any-mbg15.ca755cdb.png";